// auth/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem('token'));
  const [role, setRole] = useState(() => localStorage.getItem('role'));
  const [accountId, setAccountId] = useState(() => localStorage.getItem('accountId'));

  useEffect(() => {
    token ? localStorage.setItem('token', token) : localStorage.removeItem('token');
  }, [token]);

  useEffect(() => {
    role ? localStorage.setItem('role', role) : localStorage.removeItem('role');
  }, [role]);

  useEffect(() => {
    accountId ? localStorage.setItem('accountId', accountId) : localStorage.removeItem('accountId');
  }, [accountId]);

  return (
    <AuthContext.Provider value={{ token, setToken, role, setRole, accountId, setAccountId }}>
      {children}
    </AuthContext.Provider>
  );
};
